import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const leadingZero = number => `0${number}`.slice(-2);

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class FlipBoard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      leftNumber: 0,
      rightNumber: 0,
      currentNumber: null,
      answerStyle: false,
    };
  }

  componentDidMount() {
    this.matchStep();
  }

  getCurrentNumber(parsed) {
    const { leftNumber, rightNumber } = this.state;
    if (parsed) {
      return parseInt(`${leftNumber}${rightNumber}`, 10);
    }
    return `${leftNumber}${rightNumber}`;
  }

  matchStep(e) {
    const { steps } = this.props;
    const { currentNumber } = this.state;

    if (steps !== undefined && currentNumber === null) {
      const leftNumber = leadingZero(steps[0])[0];
      const rightNumber = leadingZero(steps[0])[1];
      this.setState({
        leftNumber,
        rightNumber,
        currentNumber: 0,
      });
      return true;
    }

    if (e !== undefined && e.target.id === 'plus' && steps !== undefined && currentNumber < steps.length - 1) {
      this.setState({
        currentNumber: currentNumber + 1,
        leftNumber: leadingZero(steps[currentNumber + 1])[0],
        rightNumber: leadingZero(steps[currentNumber + 1])[1],
      });
      return true;
    }

    if (e !== undefined && e.target.id === 'minus' && steps !== undefined && currentNumber > 0) {
      this.setState({
        currentNumber: currentNumber - 1,
        leftNumber: leadingZero(steps[currentNumber - 1])[0],
        rightNumber: leadingZero(steps[currentNumber - 1])[1],
      });
      return true;
    }

    return false;
  }

  checkAnswer() {
    const {
      correctAnswer, contentComplete, correctAnswerText, incorrectAnswerText, error,
    } = this.props;

    if (correctAnswer === `${this.getCurrentNumber(true)}`) {
      this.setState({ answerStyle: true });
      toast.success(correctAnswerText, {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      contentComplete();
    } else {
      toast.error(incorrectAnswerText, {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      error();
      this.setState({ answerStyle: false });
    }
  }

  render() {
    const { leftNumber, rightNumber } = this.state;
    const { question, disableHeader } = this.props;
    return (
      <div className="container__question">
        {!disableHeader && <div className="container__question--image" />}
        <div className="container__question--content">
          <h4 className="container__title">{question}</h4>
          <div className="flipBoard__container">
            <div className="flipBoard">
              <button id="plus" onClick={(e) => { this.matchStep(e); }} className="flipButton plus" />
              <button id="minus" onClick={(e) => { this.matchStep(e); }} className="flipButton minus" />
            </div>
            <div className="flipNumbers">
              <div className="number left">{leftNumber}</div>
              <div className="number right">{rightNumber}</div>
            </div>
          </div>
          <ToastContainer
            draggablePercent={70}
          />
          <button
            onClick={() => { this.checkAnswer(); }}
            style={this.state.answerStyle ? { backgroundColor: '#6cd488' } : null}
          >
              Submit
          </button>
        </div>
      </div>
    );
  }
}

FlipBoard.propTypes = {
  correctAnswer: PropTypes.string.isRequired,
  contentComplete: PropTypes.func.isRequired,
  incorrectAnswerText: PropTypes.string,
  correctAnswerText: PropTypes.string,
  question: PropTypes.string.isRequired,
  error: PropTypes.func,
  disableHeader: PropTypes.bool,
};

FlipBoard.defaultProps = {
  incorrectAnswerText: '',
  correctAnswerText: '',
  error: () => {},
  disableHeader: false,
};
